import { Fragment } from "react";
import { Link } from "react-router-dom";

// Minimal markdown: ### headings, bullets, **bold**, relative links (/path) and bare URLs.
const inline = (text, keyBase) => {
  const parts = text.split(/(\*\*[^*]+\*\*|\(\/[a-z0-9\-/]+\)|\/(?:locations|journal|intelligence|land-and-law|advisory|guided|about)[a-z0-9\-/]*|https?:\/\/[^\s)]+)/g);
  return parts.map((p, i) => {
    const k = `${keyBase}-${i}`;
    if (!p) return null;
    if (p.startsWith("**")) return <strong key={k} className="font-medium text-[#1A1C1E]">{p.slice(2, -2)}</strong>;
    if (p.startsWith("(/")) {
      const to = p.slice(1, -1);
      return <Fragment key={k}>(<Link to={to} className="ss-link text-[#2D3B32]" data-testid="assistant-internal-link">{to}</Link>)</Fragment>;
    }
    if (p.startsWith("/")) return <Link key={k} to={p} className="ss-link text-[#2D3B32]" data-testid="assistant-internal-link">{p}</Link>;
    if (p.startsWith("http")) return <a key={k} href={p} target="_blank" rel="noopener noreferrer" className="ss-link text-[#2D3B32] break-all">{p.replace(/^https?:\/\//, "")}</a>;
    return <Fragment key={k}>{p}</Fragment>;
  });
};

export const AssistantMarkdown = ({ text }) => {
  const lines = text.split("\n");
  const blocks = [];
  let list = null;
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)$/);
    if (bullet) {
      if (!list) { list = []; blocks.push({ type: "ul", items: list }); }
      list.push(bullet[1]);
      return;
    }
    list = null;
    if (!line.trim()) return;
    const h = line.match(/^#{1,4}\s+(.*)$/);
    if (h) blocks.push({ type: "h", text: h[1] });
    else blocks.push({ type: "p", text: line });
  });
  return (
    <div className="space-y-3">
      {blocks.map((b, i) => {
        if (b.type === "h") return <p key={i} className="ss-overline !text-[#8C6A53] pt-1">{inline(b.text, i)}</p>;
        if (b.type === "ul") return (
          <ul key={i} className="space-y-1.5 pl-4">
            {b.items.map((it, j) => <li key={j} className="relative before:content-['–'] before:absolute before:-left-4 before:text-[#8A9098]">{inline(it, `${i}-${j}`)}</li>)}
          </ul>
        );
        return <p key={i}>{inline(b.text, i)}</p>;
      })}
    </div>
  );
};
